import * as Logger from '@/lib/monitoring/logger';

const STORAGE_KEY_DISMISSED_AT = 'upstack.pwa.dismissed_at';
const STORAGE_KEY_IOS_DISMISSED_AT = 'upstack.pwa.ios_dismissed_at';
const STORAGE_KEY_INSTALLED = 'upstack.pwa.installed';

const ANDROID_DISMISS_TTL_MS = 14 * 24 * 60 * 60 * 1000;
const IOS_DISMISS_TTL_MS = 30 * 24 * 60 * 60 * 1000;

function safeRead(key: string): string | undefined {
  try {
    return window.localStorage.getItem(key) ?? undefined;
  } catch {
    return undefined;
  }
}

function safeWrite(key: string, value: string): void {
  try {
    window.localStorage.setItem(key, value);
  } catch (error) {
    Logger.warn('Failed to write install banner state', { error, key });
  }
}

export function isAndroidDismissActive(now: number = Date.now()): boolean {
  const raw = safeRead(STORAGE_KEY_DISMISSED_AT);
  if (!raw) return false;
  const dismissedAt = Number(raw);
  if (!Number.isFinite(dismissedAt)) return false;
  return now - dismissedAt < ANDROID_DISMISS_TTL_MS;
}

export function isIosDismissActive(now: number = Date.now()): boolean {
  const raw = safeRead(STORAGE_KEY_IOS_DISMISSED_AT);
  if (!raw) return false;
  const dismissedAt = Number(raw);
  if (!Number.isFinite(dismissedAt)) return false;
  return now - dismissedAt < IOS_DISMISS_TTL_MS;
}

export function recordAndroidDismiss(now: number = Date.now()): void {
  safeWrite(STORAGE_KEY_DISMISSED_AT, String(now));
}

export function recordIosDismiss(now: number = Date.now()): void {
  safeWrite(STORAGE_KEY_IOS_DISMISSED_AT, String(now));
}

export function isAlreadyInstalled(): boolean {
  return safeRead(STORAGE_KEY_INSTALLED) === 'true';
}

export function recordInstalled(): void {
  safeWrite(STORAGE_KEY_INSTALLED, 'true');
}
